/*
  VM Test — quiz "¿Dónde estás en tu transformación?"
  Lee preguntas/resultados del JSON embebido en la sección ([data-vm-test-data])
  y maneja intro → preguntas → email → resultado con transiciones CSS.

  Dos tipos de pregunta: "camino" (suma puntos a uno de los 4 caminos, opciones
  barajadas por sesión) y "perfil" (guarda una dimensión: etapa, tiempo, formato;
  orden fijo). Todo viaja en contact[tags]: camino ganador, camino secundario y
  cada dimensión de perfil, para segmentar y personalizar correos en Klaviyo.

  El correo se envía con el form nativo de Shopify (POST full-page, no AJAX):
  así el challenge anti-spam de Shopify no pierde el lead. El resultado viaja
  de vuelta en ?camino=<key>&camino2=<key> vía return_to, con respaldo en
  sessionStorage para el caso de re-render con errores de validación.
*/
(function () {
  'use strict';

  var REDUCED = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var STORAGE_KEY = 'vm-test-result';

  function readStorage() {
    try { return window.sessionStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }
  function writeStorage(value) {
    try { window.sessionStorage.setItem(STORAGE_KEY, value); } catch (e) { /* noop */ }
  }
  function clearStorage() {
    try { window.sessionStorage.removeItem(STORAGE_KEY); } catch (e) { /* noop */ }
  }

  function initTest(root) {
    if (root.dataset.vmTestReady) return;
    root.dataset.vmTestReady = '1';

    var dataEl = root.querySelector('[data-vm-test-data]');
    if (!dataEl) return;

    var data;
    try {
      data = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }

    var questions = (data.questions || []).filter(function (q) { return q.text; });
    var results = data.results || [];
    if (!questions.length || !results.length) return;

    var screens = {
      intro: root.querySelector('[data-vm-ts-screen="intro"]'),
      question: root.querySelector('[data-vm-ts-screen="question"]'),
      email: root.querySelector('[data-vm-ts-screen="email"]'),
      result: root.querySelector('[data-vm-ts-screen="result"]')
    };
    var qInner = root.querySelector('[data-vm-ts-q-inner]');
    var qLabel = root.querySelector('[data-vm-ts-q-label]');
    var qFill = root.querySelector('[data-vm-ts-q-fill]');
    var qTitle = root.querySelector('[data-vm-ts-q-title]');
    var qOpts = root.querySelector('[data-vm-ts-opts]');

    var optClass = null;
    var dotClass = null;

    var state = { index: 0, scores: {}, profile: {} };

    function shuffle(arr) {
      for (var i = arr.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var tmp = arr[i];
        arr[i] = arr[j];
        arr[j] = tmp;
      }
      return arr;
    }

    function showScreen(name, focusEl) {
      Object.keys(screens).forEach(function (key) {
        var el = screens[key];
        if (!el) return;
        if (key === name) {
          el.hidden = false;
          if (!REDUCED) {
            el.classList.add('is-entering');
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                el.classList.remove('is-entering');
              });
            });
          }
        } else {
          el.hidden = true;
        }
      });
      window.scrollTo(0, 0);
      if (focusEl) focusEl.focus({ preventScroll: true });
    }

    function renderQuestion() {
      var q = questions[state.index];
      var total = questions.length;
      var label = (data.questionLabel || 'Pregunta [n] de [total]')
        .replace('[n]', state.index + 1)
        .replace('[total]', total);

      qLabel.textContent = label;
      qFill.style.width = (((state.index + 1) / total) * 100) + '%';
      qTitle.textContent = q.text;

      qOpts.innerHTML = '';
      q.options.forEach(function (opt) {
        if (!opt.text) return;
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = optClass;
        var span = document.createElement('span');
        span.textContent = opt.text;
        var dot = document.createElement('span');
        dot.className = dotClass;
        dot.setAttribute('aria-hidden', 'true');
        btn.appendChild(span);
        btn.appendChild(dot);
        btn.addEventListener('click', function () {
          selectOption(btn, opt.key);
        });
        qOpts.appendChild(btn);
      });
    }

    function selectOption(btn, key) {
      if (qOpts.dataset.locked) return;
      qOpts.dataset.locked = '1';
      btn.classList.add('is-selected');
      var q = questions[state.index];
      if (q.kind === 'perfil' && q.dim) {
        state.profile[q.dim] = key;
      } else {
        state.scores[key] = (state.scores[key] || 0) + 1;
      }

      window.setTimeout(function () {
        delete qOpts.dataset.locked;
        if (state.index < questions.length - 1) {
          state.index += 1;
          swapQuestion();
        } else {
          finishQuiz();
        }
      }, REDUCED ? 80 : 350);
    }

    function swapQuestion() {
      if (REDUCED) {
        renderQuestion();
        qTitle.focus({ preventScroll: true });
        return;
      }
      qInner.classList.add('is-swapping');
      window.setTimeout(function () {
        renderQuestion();
        qInner.classList.remove('is-swapping');
        qTitle.focus({ preventScroll: true });
      }, 300);
    }

    function bestResult() {
      var best = null;
      var max = -1;
      results.forEach(function (r) {
        var score = state.scores[r.key] || 0;
        if (score > max) {
          max = score;
          best = r;
        }
      });
      return best || results[0];
    }

    function secondResult(winnerKey) {
      var best = null;
      var max = 0;
      results.forEach(function (r) {
        if (r.key === winnerKey) return;
        var score = state.scores[r.key] || 0;
        if (score > max) {
          max = score;
          best = r;
        }
      });
      return best;
    }

    function resultByKey(key) {
      var found = null;
      results.forEach(function (r) {
        if (r.key === key) found = r;
      });
      return found;
    }

    function finishQuiz() {
      var r = bestResult();
      var r2 = secondResult(r.key);
      var tagParts = ['vm-test', 'camino-' + r.key];
      if (r2) tagParts.push('camino2-' + r2.key);
      Object.keys(state.profile).forEach(function (dim) {
        tagParts.push(dim + '-' + state.profile[dim]);
      });
      var payload = { c: r.key, c2: r2 ? r2.key : '', t: tagParts.join(', ') };
      if (!screens.email) {
        showResult(payload.c, payload.c2);
        return;
      }
      writeStorage(JSON.stringify(payload));
      prepareLeadForm(payload);
      showScreen('email', root.querySelector('[data-vm-ts-e-title]'));
    }

    function prepareLeadForm(payload) {
      var tags = root.querySelector('[data-vm-ts-tags]');
      if (tags) tags.value = payload.t || 'vm-test, camino-' + payload.c;
      var ret = root.querySelector('[data-vm-ts-return]');
      if (ret) {
        var query = '?camino=' + encodeURIComponent(payload.c);
        if (payload.c2) query += '&camino2=' + encodeURIComponent(payload.c2);
        ret.value = window.location.pathname + query;
      }
    }

    function showResult(key, key2) {
      renderResult(key, key2);
      showScreen('result', root.querySelector('[data-vm-ts-r-name]'));
    }

    function renderResult(key, key2) {
      var r = resultByKey(key) || bestResult();
      var r2 = key2 ? resultByKey(key2) : null;
      var orb = root.querySelector('[data-vm-ts-r-orb]');
      var cover = root.querySelector('[data-vm-ts-r-cover]');
      var caption = root.querySelector('[data-vm-ts-r-caption]');
      var name = root.querySelector('[data-vm-ts-r-name]');
      var sub = root.querySelector('[data-vm-ts-r-sub]');
      var msg = root.querySelector('[data-vm-ts-r-msg]');
      var cta = root.querySelector('[data-vm-ts-r-cta]');

      orb.src = r.orb || '';
      if (r.cover) {
        cover.hidden = false;
        cover.style.backgroundImage = 'url("' + r.cover + '")';
      } else {
        cover.hidden = true;
      }
      caption.textContent = r.caption || '';
      caption.hidden = !r.caption;
      name.textContent = r.name || '';
      name.style.color = r.color || '';
      sub.textContent = r.sub || '';
      sub.hidden = !r.sub;
      msg.textContent = r.msg || '';
      var matiz = root.querySelector('[data-vm-ts-r-matiz]');
      if (matiz) {
        if (r2 && data.matizTemplate) {
          matiz.textContent = data.matizTemplate.replace('[camino]', r2.name);
          matiz.hidden = false;
        } else {
          matiz.hidden = true;
        }
      }
      if (r.ctaUrl) {
        cta.href = r.ctaUrl;
        cta.removeAttribute('aria-disabled');
      } else {
        cta.removeAttribute('href');
        cta.setAttribute('role', 'link');
        cta.setAttribute('aria-disabled', 'true');
      }
      cta.textContent = r.ctaLabel || '';
      cta.parentElement.hidden = !r.ctaLabel;
    }

    function start() {
      state.index = 0;
      state.scores = {};
      state.profile = {};
      questions.forEach(function (q) {
        if (q.kind !== 'perfil') shuffle(q.options);
      });
      renderQuestion();
      showScreen('question', qTitle);
    }

    /* Clases scoped: derivarlas de los sufijos ya presentes en el DOM de la sección. */
    (function resolveClasses() {
      var track = qFill.className.match(/vm-ts-q-fill-(\S+)/);
      var suffix = track ? track[1] : '';
      optClass = 'vm-ts-opt-' + suffix;
      dotClass = 'vm-ts-opt-dot-' + suffix;
    })();

    var startBtn = root.querySelector('[data-vm-ts-start]');
    if (startBtn) startBtn.addEventListener('click', start);

    var restartBtn = root.querySelector('[data-vm-ts-restart]');
    if (restartBtn) {
      restartBtn.addEventListener('click', function () {
        state.index = 0;
        state.scores = {};
        state.profile = {};
        clearStorage();
        showScreen('intro', startBtn);
      });
    }

    /* Regreso del POST del lead: ?camino=<key>&camino2=<key> en la URL muestra
       el resultado directo; si Shopify re-renderizó con errores de validación,
       se reabre el gate con el estado respaldado en sessionStorage. */
    (function restoreFromNavigation() {
      var camino = null;
      var camino2 = null;
      try {
        var params = new URLSearchParams(window.location.search);
        camino = params.get('camino');
        camino2 = params.get('camino2');
      } catch (e) { /* noop */ }

      if (camino && resultByKey(camino)) {
        clearStorage();
        showResult(camino, camino2 && resultByKey(camino2) ? camino2 : '');
        if (window.history && window.history.replaceState) {
          window.history.replaceState({}, '', window.location.pathname);
        }
        return;
      }

      var stored = readStorage();
      var payload = null;
      if (stored) {
        try { payload = JSON.parse(stored); } catch (e) { payload = { c: stored, c2: '', t: '' }; }
      }
      if (payload && resultByKey(payload.c) && screens.email && root.querySelector('[data-vm-ts-e-error]')) {
        prepareLeadForm(payload);
        showScreen('email', root.querySelector('[data-vm-ts-e-title]'));
      }
    })();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-vm-test]').forEach(initTest);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(document); });
  } else {
    initAll(document);
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
  }
})();
